export const MouseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="55" viewBox="0 0 38 55" fill="none">
      <rect x="0.75" y="0.75" width="36.5" height="53.5" rx="15.4062" stroke="#B9BCCB" strokeWidth="1.5" />
      <line x1="0.00230613" y1="22.1362" x2="37.0023" y2="22.25" stroke="#B9BCCB" strokeWidth="1.5" />
      <line
        x1="18.7487"
        y1="7.82443"
        x2="18.7487"
        y2="16.5453"
        stroke="#BB96FF"
        strokeWidth="2.72308"
        strokeLinecap="round"
      />
    </svg>
  );
};
